<button type="button" class="btn-custom-6" (click)="_open()">
      <strong>Esgotado</strong>
</button>      